import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { useHistory } from 'react-router-dom'
import { Box } from '@mui/material'

const GoBackButton = ({ label, andThisAction, customBackLink }) => {
  const history = useHistory()

  const onClickHandler = () => {
    if (customBackLink) {
      history.push(customBackLink)
      andThisAction()
    } else {
      history.goBack()
      andThisAction?.()
    }
  }

  return (
    <Box sx={styles.GoBackButton} onClick={() => onClickHandler()}>
      <ChevronLeftIcon /> {label}
    </Box>
  )
}

const styles = {
  GoBackButton: {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#92929d',
    lineHeight: 1.33,
    padding: { xs: '8px 0', sm: '16px 0 8px' },
    fontSize: { xs: 10, sm: 12 },
    textDecoration: 'none',
    cursor: 'pointer',
    '& svg': {
      fontSize: 16,
    },
  },
}

export default GoBackButton
